import { createSelector } from 'reselect';
import { ApplicationRootState } from '../../types';
import { initialState } from './reducer';

/**
 * Direct selector to the instructorAddClasses state domain
 */

const selectInstructorAddClassesDomain = (state: ApplicationRootState) => {
  return state.instructorAddClasses || initialState;
};

/**
 * Other specific selectors
 */

/**
 * Default selector used by InstructorAddClasses
 */

const makeSelectInstructorAddClasses = () =>
  createSelector(
    selectInstructorAddClassesDomain,
    substate => {
      return substate;
    },
  );

export default makeSelectInstructorAddClasses;
export { selectInstructorAddClassesDomain };
